var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-k-v',{attrs:{"titulo":"Último Acesso","md":3,"lg":2,"xl":1,"dado":_vm.ultimoAcesso
            ? ((_vm.$maskDateTime(_vm.ultimoAcesso)) + " (" + (_vm.$moment(
                  _vm.ultimoAcesso
              ).fromNow()) + ")")
            : 'SEM ACESSO REGISTRADO'}})}
var staticRenderFns = []

export { render, staticRenderFns }